export default __webpack_public_path__ + "static/media/place_holder_Piechart.2e73418c.svg";